<div class="row text-center">
  <div class="col-md-8">
    <div class="btn-group">
      <p-button type="button" styleClass="btn" (onClick)="prevMonth()" label="Previous"></p-button>
      <p-button type="button" styleClass="btn" (onClick)="curMonth()" label="Today"></p-button>
      <p-button type="button" styleClass="btn" (onClick)="nextMonth()" label="Next"></p-button>
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-8">
    <div class="card bg-light">
      <div class="card-header">
        <h3>Calendar {{ viewDate.toLocaleDateString() }}</h3>
      </div>
      <div class="card-body">
        <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [refresh]="refresh" (eventTimesChanged)="eventTimesChanged($event)" [cellTemplate]="customCellTemplate" weekStartsOn="1"> </mwl-calendar-month-view>
        <ng-template #customCellTemplate let-day="day">
          <div class="cal-cell-top">
            <span class="cal-day-number">{{ day.date | calendarDate : "monthViewDayNumber" : locale }}</span>
          </div>
          @if (day.events) {
            <div [ngStyle]="{ position: 'relative' }">
              @for (event of day.events; track event) {
                <p (click)="eventClicked(event)" [ngStyle]="{ 'background-color': event.color.primary, width: '100%', height: '20px', 'margin-bottom': '2px' }">
                  <span class="text-white small" [ngStyle]="{ overflow: 'hidden', 'white-space': 'nowrap', 'text-overflow': 'ellipsis', 'max-width': '92px', display: 'flex', 'justify-content': 'center' }">{{ event.meta?.name }}</span>
                </p>
              }
            </div>
          }
        </ng-template>
      </div>
    </div>
  </div>
  @if (selectedEvent) {
    <div class="col-md-4">
      <div [ngClass]="get_status(selectedEvent.meta.over)">
        <div class="card-header">
          <h3>Reservation</h3>
        </div>
        <div class="card-body">
          @if (msg) {
            <div class="alert alert-success">{{ msg }}</div>
          }
          @if (errmsg) {
            <div class="alert alert-danger">{{ errmsg }}</div>
          }
          <div class="table-responsive">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th>Owner</th>
                  <td>
                    <a routerLink="/user/{{ selectedEvent.meta.owner }}">{{ selectedEvent.meta.owner }}</a>
                  </td>
                </tr>
                <tr>
                  <th>From</th>
                  <td>{{ selectedEvent.start | date }}</td>
                </tr>
                <tr>
                  <th>To</th>
                  <td>{{ selectedEvent.end | date }}</td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{{ selectedEvent.meta.name }}</td>
                </tr>
                <tr>
                  <th>About</th>
                  <td>{{ selectedEvent.meta.about }}</td>
                </tr>
                <tr>
                  <th>Quantity</th>
                  <td>{{ selectedEvent.meta.quantity }}</td>
                </tr>
                <tr>
                  <th>Group</th>
                  <td>
                    @if (selectedEvent.meta.group && selectedEvent.meta.group?.name) {
                      <span>{{ selectedEvent.meta.group.name }}</span>
                    }
                  </td>
                </tr>
                <tr>
                  <th>Project</th>
                  <td>
                    @if (selectedEvent.meta.project && selectedEvent.meta.project.id) {
                      <span>{{ selectedEvent.meta.project.id }}</span>
                    }
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  @if (!selectedEvent.meta.created && !selectedEvent.meta.over) {
                    <td>Pending</td>
                  }
                  @if (selectedEvent.meta.created && selectedEvent.meta.over) {
                    <td>Over</td>
                  }
                  @if (selectedEvent.meta.created && !selectedEvent.meta.over) {
                    <td>Active</td>
                  }
                  @if (!selectedEvent.meta.created && selectedEvent.meta.over) {
                    <td>Cancelled</td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
          @if (selectedEvent.meta.students.length > 0) {
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Accounts</th>
                  </tr>
                </thead>
                <tbody>
                  @for (account of selectedEvent.meta.students; track account) {
                    <tr>
                      <td>
                        <a routerLink="/user/{{ account }}">{{ account }}</a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (!selectedEvent.meta.created && !selectedEvent.meta.over && session_user.is_admin) {
            <p-button severity="primary" size="small" (onClick)="create_reservation()" label="Create"></p-button>
          }
          @if (!selectedEvent.meta.created && !selectedEvent.meta.over && authorized) {
            <p-button severity="secondary" size="small" (onClick)="cancel_reservation()" label="Cancel"></p-button>
          }
          @if (selectedEvent.meta.created && !selectedEvent.meta.over && session_user.is_admin) {
            <p-button severity="primary" size="small" type="button" data-bs-toggle="modal" data-bs-target="#extend" label="Extend"></p-button>
          }
          @if (selectedEvent.meta.created && !selectedEvent.meta.over && session_user.is_admin) {
            <p-button severity="warn" size="small" (onClick)="remove_reservation()" label="Remove"></p-button>
          }
        </div>
      </div>
    </div>
  }
</div>


<div class="modal" style="z-index: 1500" id="extend" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Extend TP {{ selectedEvent ? selectedEvent.meta.name : "" }}</h3>
      </div>
      <form aria-label="TP extension request form" role="form" class="user-form form-horizonal">
        <div class="modal-body">
          <div class="form-group row col-sm-8">
            <label for="new_expire">
              New Expiration Date&nbsp;
              <span style="color: red">(required)&nbsp;</span>
              <span class="glyphicon glyphicon-question-sign" title="Project expiration date" tooltip></span>
            </label>
            <input required id="new_expire" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_expire" type="date" class="form-control" />
          </div>
        </div>
        <div class="modal-footer">
          <div class="form-group row col-sm-12">
            <p-button severity="primary" size="small" type="button" (onClick)="extend_reservation()" data-bs-dismiss="modal" label="Extend"></p-button>
            <p-button severity="secondary" size="small" type="button" data-bs-dismiss="modal" label="Cancel"></p-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>


@if (authorized) {
  <div class="row">
    <div class="col-md-8">
      <div class="card bg-light">
        <div class="card-header">
          <h3>New reservation</h3>
        </div>
        <div class="card-body">
          @if (resmsg) {
            <div class="alert alert-success">{{ resmsg }}</div>
          }
          @if (reserrmsg) {
            <div class="alert alert-danger">{{ reserrmsg }}</div>
          }
          <form #tpForm="ngForm" role="form" class="user-form form-horizontal" (ngSubmit)="reserve(tpForm)" novalidate>
            <div class="col-md-4">
              <label for="quantity" class="control-label">Number of students</label>
              <input required type="number" class="form-control" [(ngModel)]="quantity" name="quant" #quant="ngModel" id="tp_quantity" />
              @if (quant.invalid && (quant.dirty || quant.touched)) {
                <div class="text-danger">
                  @if (quant.errors?.required) {
                    <div>Number of students required</div>
                  }
                </div>
              }
            </div>
            <div class="col-md-4">
              <label for="from_date" class="control-label">From</label>
              <input required [(ngModel)]="fromDate" type="date" class="form-control" name="from" #from="ngModel" id="tp_from" />
              @if (from.invalid && (from.dirty || from.touched)) {
                <div class="text-danger">
                  @if (from.errors?.required) {
                    <div>TP start date required</div>
                  }
                </div>
              }
            </div>
            <div class="col-md-4">
              <label for="to_date" class="control-label">To</label>
              <input required [(ngModel)]="toDate" type="date" class="form-control" name="to" #to="ngModel" id="tp_to" />
              @if (to.invalid && (to.dirty || to.touched)) {
                <div class="text-danger">
                  @if (to.errors?.required) {
                    <div>TP end date required</div>
                  }
                </div>
              }
            </div>
            <div class="col-md-8">
              <label for="name" class="control-label">Training Name</label>
              <input required [(ngModel)]="name" type="text" class="form-control" name="id" #id="ngModel" id="tp_name" />
              @if (id.invalid && (id.dirty || id.touched)) {
                <div class="text-danger">
                  @if (id.errors?.required) {
                    <div>TP name required</div>
                  }
                </div>
              }
            </div>
            <div class="col-md-12">
              <label for="about">About</label>
              <textarea required [(ngModel)]="about" class="form-control" name="description" #description="ngModel" id="tp_about"></textarea>
              @if (description.invalid && (description.dirty || description.touched)) {
                <div class="text-danger">
                  @if (description.errors?.required) {
                    <div>TP description required</div>
                  }
                </div>
              }
            </div>
            @if (config && config.reservation && config.reservation.show_choice_in_ui) {
              <div class="form-group row">
                <div class="col-4">
                  <p>Associate account to:</p>
                </div>
                <div class="col-2">
                  <input id="group" type="radio" class="form-check-input" name="project_or_group" value="group" [(ngModel)]="group_or_project" />
                  <label for="group" class="form-check-label">Group</label>
                </div>
                <div class="col-2">
                  <input id="project" type="radio" class="form-check-input" name="project_or_group" value="project" [(ngModel)]="group_or_project" />
                  <label for="project" class="form-check-label">Project</label>
                </div>
              </div>
            }
            <div class="col-md-4">
              <label class="control-label"></label>
              <p-button severity="secondary" size="small" type="submit" label="Reserve"></p-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
